// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;In the morning, Lord, you will hear my voice;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;early in the morning I make my appeal to you, and look up.<br> </p> </div></div>";
// Exports
module.exports = code;